module.exports = __webpack_public_path__ + "img/图片1-2.63d32c9a.png";